
import {Component, Vue} from 'vue-property-decorator';
import {readAdminRoles} from '@/store/admin/getters';
import {dispatchDeleteRole, dispatchGetRolesAdmin} from '@/store/admin/actions';
import DynamicTable from '@/components/datatables/DynamicTable.vue';

@Component({
  components: {DynamicTable},
})
export default class RoleList extends Vue {

  private headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-roles-edit', width: '100px', delete_function: this.deleteRole},
    {
      text: this.$t('alias'),
      sortable: true,
      value: 'alias',
      align: 'left',
    },
    {
      text: this.$t('description'),
      sortable: true,
      value: 'description',
      align: 'left',
    },
    {
      text: this.$t('settings'),
      sortable: true,
      value: 'role_settings',
      align: 'center',
    },

  ];

  get roles() {
    return readAdminRoles(this.$store);
  }

  public async mounted() {
    await dispatchGetRolesAdmin(this.$store);
  }

  public async deleteRole(id) {
    await dispatchDeleteRole(this.$store, id);
    await dispatchGetRolesAdmin(this.$store);
  }

}
